import React from 'react'
import config from '../Config'
import { LogoIcon, Wordmark } from '../Components/Logo'
import PageHeader from '../Components/PageHeader'
import { useDocumentTitle } from '../Hooks/useDocumentTitle'
import { t } from '../i18n'

/* O nama (spec 5.11). Texts are drafts until approved (spec 11, question 2). */
function withEmail(text) {
  const [before, after] = text.split('{email}')
  return (
    <>
      {before}
      <a href={`mailto:${config.CONTACT_EMAIL}`}>{config.CONTACT_EMAIL}</a>
      {after}
    </>
  )
}

export default function AboutUs() {
  useDocumentTitle(t('footer.about'))
  return (
    <div className="about">
      <PageHeader title={t('footer.about')} />
      <div className="about-hero">
        <LogoIcon size={64} />
        <Wordmark size={32} />
        <p className="about-slogan">{t('about.slogan')}</p>
        <p className="about-intro">{t('about.intro')}</p>
      </div>

      <section className="about-section">
        <h2>{t('about.howTitle')}</h2>
        <ol className="about-steps">
          <li>
            <strong>{t('about.collectTitle')}</strong>
            <span>{t('about.collectText')}</span>
          </li>
          <li>
            <strong>{t('about.connectTitle')}</strong>
            <span>{t('about.connectText')}</span>
          </li>
          <li>
            <strong>{t('about.followTitle')}</strong>
            <span>{t('about.followText')}</span>
          </li>
        </ol>
      </section>

      <section className="about-section about-rules">
        <h2>{t('about.rulesTitle')}</h2>
        <ul>
          <li>{t('about.rules1')}</li>
          <li>{t('about.rules2')}</li>
          <li>{t('about.rules3')}</li>
        </ul>
      </section>

      <section className="about-section">
        <h2>{t('about.contactTitle')}</h2>
        <p>{withEmail(t('about.contactText'))}</p>
      </section>

      <section className="about-section about-small">
        <h2>{t('about.disclaimerTitle')}</h2>
        <p>{withEmail(t('about.disclaimer'))}</p>
      </section>
    </div>
  )
}
